export const request = (url, options) => {
  return fetch(url, options).then(response => {
    if (response.status !== 200) {
      throw new Error("reauth");
    }
    return response.json();
  });
};

export const nextStep = (questionId, questionsArray) => {
  const nextStepIndex =
    questionsArray.findIndex(step => {
      return step.id === questionId;
    }) + 1;
  if (nextStepIndex >= questionsArray.length) {
    return false;
  } else return questionsArray[nextStepIndex];
};
export const getLikeliestProducts = (products, min, max) => {
  return Object.entries(products)
    .map(entry => {
      const [productId, weights] = entry;
      return {
        productId,
        totalWeight: weights.reduce((a, b) => {
          return a + b;
        }, 0)
      };
    })
    .sort((a, b) => {
      return b.totalWeight - a.totalWeight;
    })
    .slice(parseInt(min || 0), parseInt(max || products.length));
};

export const buildHeaders = urlObject => {
  if (urlObject) {
    const requestHeaders = new Headers();
    Object.keys(urlObject).forEach(header => {
      requestHeaders.append(header, urlObject[header]);
    });
    return requestHeaders;
  }
};

export const scrollToElement = (element, alignTo) => {
  if (element) {
    element.scrollIntoView(alignTo);
  }
};
